export default "__VITE_ASSET__ad215fb8__"